var styles = {"content":"styles_content__1qk3o p2","sellable-title":"styles_sellable-title__2RlL4","sellableTitle":"styles_sellable-title__2RlL4","description":"styles_description__wXxgy","variations":"styles_variations__YWFdr flex flex-wrap","variant":"styles_variant__9eGF7 p1 flex flex-column items-center","duration":"styles_duration__8AGYT","price":"styles_price__3tFVk"};

export default styles;
//# sourceMappingURL=styles.css.js.map
